import {
	Action,
	Dispatch,
} from 'redux';
// Import action type enumeration.
import ActionType from '@app/redux/actions/types';
import { OverlayTarget } from '@app/enumerations';

interface OverlayTargetParameters {
	overlayTarget: OverlayTarget;
}

// Start Processing Action.

interface StartProcessingParameters extends OverlayTargetParameters{
	message: string;
	messageId: string;
}

type StartProcessingAction = Action & StartProcessingParameters;

const startProcessingAction: (params: StartProcessingParameters) =>
	StartProcessingAction = (params: StartProcessingParameters) => ({
		...params,
		type: ActionType.START_PROCESSING
	});

const startProcessing = (params: StartProcessingParameters) =>
	async (dispatch: Dispatch): Promise<void> => {
		dispatch<StartProcessingAction>(startProcessingAction(params));	
	};


// End Processing Action.

interface EndProcessingParameters extends OverlayTargetParameters {
	messageId: string;
}

type EndProcessingAction = Action & EndProcessingParameters;

const endProcessingAction: (params: EndProcessingParameters) =>
	EndProcessingAction = (params: EndProcessingParameters) => ({
		...params,
		type: ActionType.END_PROCESSING
	});

const endProcessing = (params: EndProcessingParameters) => 
	async (dispatch: Dispatch): Promise<void> => {
		dispatch<EndProcessingAction>(endProcessingAction(params));
	};


// Export actions.
export {
	StartProcessingAction,
	EndProcessingAction,
};

// Export action methods.
export {
	startProcessing,
	endProcessing,
};

// Export action parameters.
export {
	EndProcessingParameters,
	OverlayTargetParameters,
	StartProcessingParameters,
};

// Export action factories.
export {
	startProcessingAction,
	endProcessingAction,
}